import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

import LoginView from '../components/home/LoginView.vue';
import HomePage from '../components/home/HomePage.vue';
import RouterView from '../components/RouterView.vue';

import ListUsers from '../components/users/List-Users.vue';
import CreateUser from '../components/users/Create.vue';
import EditUser from '../components/users/Edit.vue';

import ListAlerts from '../components/alerts/List-Alerts.vue';
import CreateAlert from '../components/alerts/Create.vue';
import EditAlert from '../components/alerts/Edit.vue';

import ListClients from '../components/clients/List-Clients.vue';
import CreateClient from '../components/clients/Create.vue';
import EditClient from '../components/clients/Edit.vue';
import Export from '../components/clients/Export-Files.vue';

import ListNotes from '../components/notes/List-Notes.vue';
import CreateNote from '../components/notes/Create.vue';
import EditNote from '../components/notes/Edit.vue';

import ListDocuments from '../components/documents/List.vue';
import CreateReport from '../components/documents/Create-Report.vue';
import CreateContract from '../components/documents/Create-Contract.vue';
import CreateWorksheet from '../components/documents/Create-Worksheet.vue';
import CreateLivret from '../components/documents/Create-Livret.vue';
import CreateClientReceipt from '../components/documents/Create-Client-Receipt.vue';
import CreateClientInvoice from '../components/documents/Create-Client-Invoice.vue';
import ListCustomDocuments from '../components/documents/List-Custom.vue';
import CreateCustomInvoice from '../components/documents/Create-Custom-Invoice.vue';
import CreateCustomReceipt from '../components/documents/Create-Custom-Receipt.vue';
import CreateVTPforANRE2 from '../components/documents/Create-VTP-ANRE-2.vue';
import CreateVTPforANRE10 from '../components/documents/Create-VTP-ANRE-10.vue';
import CreateVTPforANRE2SRB from '../components/documents/Create-VTP-ANRE-2-srb.vue';
import CreateVTPforANRE10SRB from '../components/documents/Create-VTP-ANRE-10-srb.vue';

import ListTasks from '../components/tasks/List-Tasks.vue';
import CreateTask from '../components/tasks/Create.vue';
import EditTask from '../components/tasks/Edit.vue';

import ListProducts from '../views/products/ListProducts.vue';
import CreateProduct from '../views/products/CreateProduct.vue';
import EditProduct from '../views/products/EditProduct.vue';

import ListStocks from '../views/products/stocks/ListStocks.vue';
import CreateStock from '../views/products/stocks/CreateStock.vue';
import EditStock from '../views/products/stocks/EditStock.vue';

import ListExpenses from '../components/expenses/List-Expenses.vue';
import CreateExpense from '../components/expenses/Create.vue';
import EditExpenses from '../components/expenses/Edit.vue';
import CashRegister from '../components/expenses/Cash-Register.vue';

import ListAnalyzers from '../views/analyzers/ListAnalyzers.vue';
import CreateAnalyzer from '../views/analyzers/CreateAnalyzer.vue';
import EditAnalyzer from '../views/analyzers/EditAnalyzer.vue';

import SettingsFormComponent from '../views/settings/SettingsForm.vue';

import {
  hasAccess,
  PERMISSION_LEVEL_ADMIN,
  PERMISSION_LEVEL_TECHNICIAN,
  PERMISSION_LEVEL_TECHNICIAN_ANRE,
} from '../utils/permissions';
import CreatePVIUGNSrb from '../components/documents/Create-PV-IUGN-srb.vue';

Vue.use(Router);

const hasPermission = (permission) => (to, from, next) => {
  if (!store.getters['auth/isLoggedIn']) {
    return next({ path: '/login' });
  }
  if (!hasAccess(permission)) {
    return next({ path: '/clients' });
  }

  return next();
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: LoginView,
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: HomePage,
      beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
    },

    {
      path: '/users',
      component: RouterView,
      children: [
        {
          path: '',
          name: 'Utlizatori',
          component: ListUsers,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: 'create',
          name: 'Adaugare user',
          component: CreateUser,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: ':id',
          name: 'Editare user',
          component: EditUser,
          props: true,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
      ],
    },

    {
      path: '/export',
      name: 'Export fisiere',
      component: Export,
      beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
    },

    {
      path: '/cash-register',
      name: 'Registru de casa',
      component: CashRegister,
      beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
    },

    {
      path: '/alerts',
      component: RouterView,
      children: [
        {
          path: '',
          name: 'Alerte',
          component: ListAlerts,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: 'create',
          name: 'Adaugare alerta',
          component: CreateAlert,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: ':id',
          name: 'Editare Alerta',
          component: EditAlert,
          props: true,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
      ],
    },

    {
      path: '/clients',
      component: RouterView,
      children: [
        {
          path: '',
          name: 'Clienti',
          component: ListClients,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: 'create',
          name: 'Adaugare client',
          component: CreateClient,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: ':id',
          name: 'Editare client',
          component: EditClient,
          props: true,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
      ],
    },

    {
      path: '/clients/:clientId/notes',
      component: RouterView,
      children: [
        {
          path: '',
          name: 'Note',
          component: ListNotes,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: 'create',
          name: 'Adaugare nota',
          component: CreateNote,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: ':noteId',
          name: 'Editare nota',
          component: EditNote,
          props: true,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
      ],
    },

    {
      path: '/clients/:clientId/documents',
      component: RouterView,
      children: [
        {
          path: '',
          name: 'Documente',
          component: ListDocuments,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: 'create-report',
          name: 'Adaugare raport',
          component: CreateReport,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: 'edit-report/:id',
          name: 'Editare raport',
          component: CreateReport,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: 'create-contract',
          name: 'Adaugare contract',
          component: CreateContract,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: 'edit-contract/:id',
          name: 'Editare contract',
          component: CreateContract,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: 'create-worksheet',
          name: 'Adaugare fisa de lucrari',
          component: CreateWorksheet,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: 'edit-worksheet/:id',
          name: 'Editare fisa de lucrari',
          component: CreateWorksheet,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: 'create-livret',
          name: 'Adaugare livret',
          component: CreateLivret,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: 'edit-livret/:id',
          name: 'Editare livret',
          component: CreateLivret,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: 'create-receipt',
          name: 'Adaugare chitanta',
          component: CreateClientReceipt,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: 'create-invoice',
          name: 'Adaugare factura',
          component: CreateClientInvoice,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: 'edit-invoice/:id',
          name: 'Editare factura',
          component: CreateClientInvoice,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN),
        },
        {
          path: 'create-vtp-anre-2',
          name: 'Adauga VTP ANRE 2 ani',
          component: CreateVTPforANRE2,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: 'edit-vtp-anre-2/:id',
          name: 'Editare VTP ANRE 2 ani',
          component: CreateVTPforANRE2,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: 'create-vtp-anre-10',
          name: 'Adauga VTP ANRE 10 ani',
          component: CreateVTPforANRE10,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: 'edit-vtp-anre-10/:id',
          name: 'Editare VTP ANRE 10 ani',
          component: CreateVTPforANRE10,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: 'create-vtp-anre-2-srb',
          name: 'Adauga VTP ANRE 2 ani SRB',
          component: CreateVTPforANRE2SRB,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: 'edit-vtp-anre-2-srb/:id',
          name: 'Editare VTP ANRE 2 ani SRB',
          component: CreateVTPforANRE2SRB,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: 'create-vtp-anre-10-srb',
          name: 'Adauga VTP ANRE 10 ani SRB',
          component: CreateVTPforANRE10SRB,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: 'edit-vtp-anre-10-srb/:id',
          name: 'Editare VTP ANRE 10 ani SRB',
          component: CreateVTPforANRE10SRB,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: 'create-pv-iugn-srb',
          name: 'Adauga PV IUGN SRB',
          component: CreatePVIUGNSrb,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: 'edit-pv-iugn-srb/:id',
          name: 'Editare PV IUGN SRB',
          component: CreatePVIUGNSrb,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
      ],
    },

    {
      path: '/documents',
      component: RouterView,
      children: [
        {
          path: '',
          name: 'Facturi Servicii',
          component: ListCustomDocuments,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: 'create-receipt',
          name: 'Chitanta',
          component: CreateCustomReceipt,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: 'create-invoice',
          name: 'Factura',
          component: CreateCustomInvoice,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: 'edit-invoice/:id',
          name: 'Editare Factura Servicii',
          component: CreateCustomInvoice,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
      ],
    },

    {
      path: '/tasks',
      component: RouterView,
      children: [
        {
          path: '',
          name: 'Taskuri',
          component: ListTasks,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: 'create',
          name: 'Adaugare task',
          component: CreateTask,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
        {
          path: ':id',
          name: 'Editare task',
          component: EditTask,
          props: true,
          beforeEnter: hasPermission(PERMISSION_LEVEL_TECHNICIAN_ANRE),
        },
      ],
    },

    {
      path: '/expenses',
      component: RouterView,
      children: [
        {
          path: 'cash',
          name: 'Plati Cash',
          component: ListExpenses,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: 'bank',
          name: 'Plati Banca',
          component: ListExpenses,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: 'create',
          name: 'Adaugare plati',
          component: CreateExpense,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: ':id',
          name: 'Editare plati',
          component: EditExpenses,
          props: true,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
      ],
    },

    {
      path: '/products',
      component: RouterView,
      children: [
        {
          path: '',
          name: 'Produse',
          component: ListProducts,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: 'create',
          name: 'Adaugare produs',
          component: CreateProduct,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: ':id',
          name: 'Editare produs',
          component: EditProduct,
          props: true,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
      ],
    },

    {
      path: '/products/:productId/stocks',
      component: RouterView,
      children: [
        {
          path: '',
          name: 'Stocuri',
          component: ListStocks,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: 'create',
          name: 'Adaugare stoc',
          component: CreateStock,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: ':stockId',
          name: 'Editare stoc',
          component: EditStock,
          props: true,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
      ],
    },

    {
      path: '/analyzers',
      component: RouterView,
      children: [
        {
          path: '',
          name: 'Analizoare',
          component: ListAnalyzers,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: 'create',
          name: 'Adaugare analizor',
          component: CreateAnalyzer,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
        {
          path: ':id',
          name: 'Editare analizor',
          component: EditAnalyzer,
          props: true,
          beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
        },
      ],
    },

    {
      path: '/settings',
      component: SettingsFormComponent,
      name: 'Setari',
      beforeEnter: hasPermission(PERMISSION_LEVEL_ADMIN),
    },

    {
      // 404 page redirect to /
      // if the user is not logged in / will redirect to /login
      path: '*',
      redirect: '/dashboard',
    },
  ],
});

export default router;
